function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.317,
  y1: 1.127,
  x2: 0.75,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#de6704"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ef7713"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-104 -388.01)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 11301",
  d: "M12.143 0c6.706 0 15.714 12.143 15.714 12.143s-9.008 12.143-15.714 12.143a12.143 12.143 0 0 1 0-24.286z",
  transform: "rotate(90 -129.612 262.255)",
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Path 11302",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M136.5 404.26c0 8.975-16.25 20.23-16.25 20.23S104 413.235 104 404.26a16.25 16.25 0 1 1 32.5 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.5 404.26c0-3.806-1.482-7.385-4.174-10.076a14.157 14.157 0 0 0-10.076-4.174 14.157 14.157 0 0 0-10.076 4.174A14.157 14.157 0 0 0 106 404.26c0 1.645.74 3.606 2.197 5.828 1.261 1.923 3.038 4.002 5.282 6.18 2.637 2.559 5.307 4.652 6.771 5.748 1.465-1.096 4.134-3.19 6.77-5.748 2.245-2.178 4.022-4.257 5.283-6.18 1.458-2.222 2.197-4.183 2.197-5.828m2 0c0 8.975-16.25 20.23-16.25 20.23S104 413.235 104 404.26s7.275-16.25 16.25-16.25 16.25 7.275 16.25 16.25z",
  fill: "#dcdcdc"
})), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 1129",
  cx: 6.5,
  cy: 6.5,
  r: 6.5,
  transform: "rotate(90 -135.431 262.431)",
  fill: "#fff"
}));

function SvgStepperOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.5,
    height: 36.48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperOrange);
export default __webpack_public_path__ + "static/media/stepper-orange.f75db3eb.svg";
export { ForwardRef as ReactComponent };